import React from 'react';
import { Link, useLocation } from "react-router-dom";

/*
    - ihoDesignSystem
*/
import { Box, Grid, List, Typography } from '@iho-design-system/Loader';

const Tab = () => {
    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [activeTab, setActiveTab] = React.useState(['bg-gray-medium', 'bg-gray-light', 'bg-gray-light']);

    /*
        - routeTab
    */
    const location = useLocation();
    React.useEffect(() => {
        if (location.pathname === '/finance/report' || location.pathname === '/ar/finance/report') {
            setActiveTab(['bg-gray-light', 'bg-gray-ultra-light', 'bg-gray-ultra-light']);
        }
        if (location.pathname === '/finance/settlement' || location.pathname === '/ar/finance/settlement') {
            setActiveTab(['bg-gray-ultra-light', 'bg-gray-light', 'bg-gray-ultra-light']);
        }
        if (location.pathname === '/finance/bank' || location.pathname === '/ar/finance/bank') {
            setActiveTab(['bg-gray-ultra-light', 'bg-gray-ultra-light', 'bg-gray-light']);
        }
    }, [location.pathname]);

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <List
                            className={`d-flex align-center justify-content-center pointer`}>
                            <List.Item>
                                <Link
                                    to='/finance/report'>
                                    <Typography
                                        className={`${activeTab[0]} py-sm px-sm rounded-sm`}>
                                        گزارشات مالی  
                                    </Typography>
                                </Link>
                            </List.Item>
                            {type === 'B2B' &&
                                <Box
                                    className={`mx-xs`} />
                            }
                            {type === 'B2B' &&
                                <List.Item>
                                    <Link
                                        to='/finance/settlement'>
                                        <Typography
                                            className={`${activeTab[1]} py-sm px-sm rounded-sm`}>
                                            گزارش تسویه
                                        </Typography>
                                    </Link>
                                </List.Item>
                            }
                            <Box
                                className={`mx-xs`} />
                            <List.Item>
                                <Link
                                    to='/finance/bank'>
                                    <Typography
                                        className={`${activeTab[2]} py-sm px-sm rounded-sm`}>
                                        گزارش بانکی
                                    </Typography>
                                </Link>
                            </List.Item>
                        </List>
                        <Box
                            className={`my-sm mb-0 divider-horizontal divider-light`} />
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
            <Box
                className={`my-lg`} />
        </React.Fragment>
    )

}

export default Tab;